import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import customParseFormat from "dayjs/plugin/customParseFormat";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import "dayjs/locale/ar";

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.extend(quarterOfYear);

// Persisted timestamps (sellDate, createdAt, ...) are stored as UTC wall-clock
// values but the API echoes them back WITHOUT a timezone suffix, so a plain
// dayjs(value) parses the UTC digits as if they were local and shows the wrong
// clock (e.g. a 7:00 PM UTC+6 sale renders as 12:59 PM). Render stored
// timestamps through toLocal() so the UTC instant is converted to the viewer's
// local zone. Robust whether or not the string carries a trailing "Z".
export const toLocal = (value) => dayjs.utc(value).local();

export default dayjs;
